import React, { ReactElement, useEffect, useState } from 'react'
import { Flex } from 'theme-ui'
import useQueryString from 'utils/useQueryString'
import ProgressBarStep from './ProgressBarStep'
import { PlansSteps } from '../usePlanWizardSteps'

export default function PlansProgressBar({
  stepNames,
}: {
  stepNames?: string[]
}): ReactElement | null {
  const { qs } = useQueryString()
  const [currentStepIndex, setCurrentStepIndex] = useState(0)

  useEffect(() => {
    stepNames && setCurrentStepIndex(stepNames.findIndex(s => s === qs.step))
  }, [stepNames, qs.step])

  if (currentStepIndex == -1 && qs.step === PlansSteps.SUCCESS) {
    setCurrentStepIndex(4)
  }
  return stepNames ? (
    <Flex sx={{ flex: 1, justifyContent: 'center' }}>
      <Flex sx={{ gap: '0.8rem', alignItems: 'center' }}>
        {stepNames.map((stepName, index): ReactElement => {
          return (
            <ProgressBarStep
              key={stepName}
              index={index}
              stepNames={stepNames}
              currentStepIndex={currentStepIndex}
              stepName={stepName}
            />
          )
        })}
      </Flex>
    </Flex>
  ) : null
}
